export enum ETipoRelatorioProjecaoFinanceira {
    Diaria = 1,
    Mensal = 2,
}
